import { useCallback, useState } from "react";

import { DEFAULT_LANGUAGE } from "../constants";

export default function useDefaultLanguage() {
  const [defaultLanguage, _setDefaultLanguage] = useState<number>(
    Number(window.localStorage.getItem(DEFAULT_LANGUAGE))
  );

  const setDefaultLanguage = useCallback((languageId: number) => {
    window.localStorage.setItem(DEFAULT_LANGUAGE, languageId.toString());
    _setDefaultLanguage(languageId);
  }, []);

  return [defaultLanguage, setDefaultLanguage] as const;
}
